exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".holder--1vgCA {\n\tposition: relative;\n\tmargin-top: 15px;\n}\n\n\t.holder--1vgCA:after{\n\t\tposition: absolute;\n\t\tcontent: '';\n\t\tleft: 0;\n\t\tright: 0;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tbackground: rgba(51,51,51,0.72157);\n\t}\n.info--3SUsT{\n\tpadding: 5px;\n\tborder: 1px solid #fff;\n\tcolor: #fff;\n\tmargin-bottom: 10px;\n}", ""]);

// Exports
exports.locals = {
	"holder": "holder--1vgCA",
	"info": "info--3SUsT"
};